<script setup lang="ts">
import { computed } from 'vue'
import type { Recording } from '../types'

const props = defineProps<{ recording: Recording }>()

const text = computed(() => {
  if (props.recording.status === 'queued') return 'В очереди'
  if (props.recording.status === 'transcribing') {
    return props.recording.chunksTotal > 0
      ? `Расшифровка… ${props.recording.chunksDone} из ${props.recording.chunksTotal}`
      : 'Подготовка расшифровки…'
  }
  if (props.recording.status === 'done') return 'Готово'
  return 'Нужна проверка'
})
</script>

<template>
  <span class="status" :class="`status--${recording.status}`">{{ text }}</span>
</template>
